import request from "./../utils/request";

export function getCatalogCategory() {
    return request({
        url: `/catalogCategory/`,
        method: "get",
    });
}

export function createCatalogCategory(data) {
    return request({
        url: "/catalogCategory/",
        method: "post",
        data: data,
    });
}

export function updateCatalogCategory(id, data) {
    return request.put(`/catalogCategory/${id}`, data);
}

export function deleteCatalogCategory(id) {
    return request.delete(`/catalogCategory/${id}`);
}

export function getCatalogCategoryById(id) {
    return request.get(`/catalogCategory/${id}`);
}
